module.exports = __webpack_public_path__ + "media/images/number_5_red-16daebdca837811d770a879f6b5b2c15.png";